import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export const Lightbox = ({ src, alt, label, testid, thumbClass = "aspect-square" }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button type="button" data-testid={`${testid}-open`} className="group w-full flex flex-col gap-2 text-left">
        <div className={`relative w-full rounded-2xl bg-white border border-slate-200/80 p-3 overflow-hidden ${thumbClass}`}>
          <img src={src} alt={alt} className="absolute inset-0 w-full h-full object-contain p-3" loading="lazy" />
          <span className="absolute right-2 bottom-2 w-8 h-8 rounded-full bg-slate-900/70 text-white flex items-center justify-center opacity-80 group-hover:opacity-100 transition-opacity">
            <ZoomIn className="w-4 h-4" />
          </span>
        </div>
        <span className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{label}</span>
      </button>
    </DialogTrigger>
    <DialogContent data-testid={`${testid}-dialog`} className="max-w-4xl w-[95vw] p-4 sm:p-6 rounded-2xl">
      <DialogTitle className="font-display text-lg">{label}</DialogTitle>
      <img src={src} alt={alt} className="w-full max-h-[78vh] object-contain" />
    </DialogContent>
  </Dialog>
);
